import React, { useEffect, useState } from 'react';
import { singleton } from "tsyringe";
import { Config } from "../config";
import { fetchAndGetArrayBuffer, fetchAndGetText, fetchAndThrowHttpErrors, fetchBinaryAndThrowHttpErrors, uuidv4 } from "../utils/helpers";
import { Asset, tagMediaTypeMapping } from "../models/assetClass";
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import { container } from 'tsyringe';
import { UserService } from './user-service';
import { Client, Message } from '@stomp/stompjs';
import * as R from 'ramda';
import { MediaType } from '../models/mediaClass';
import { SEAMApiService } from './seamapi-service';
import { PTApiService } from './ptapi-service';
import { filter } from 'lodash';

@singleton()
export class AssetManagementService {

  private endpointUrl = `${Config.BJ_ASSETMANAGEMENT_API}`;
  private userService: UserService = container.resolve(UserService);
  private ptApiService: PTApiService = container.resolve(PTApiService);
  private seamApiService: SEAMApiService = container.resolve(SEAMApiService);

  public assetList$: BehaviorSubject<Asset[]> = new BehaviorSubject<Asset[]>(null);
  public assetListOrg$: BehaviorSubject<Asset[]> = new BehaviorSubject<Asset[]>(null);
  public uploadPercentage$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public uploadAssetKey$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  public currentUploadingType$: BehaviorSubject<MediaType> = new BehaviorSubject<MediaType>(MediaType.NONE);

  // TODO remove filtering when delete assets is FIXED
  deletedAssets = [
    // "14cbc4d7-2267-4897-a8d4-83974c1f039f",
    // "eea8c1c1-04a6-43c4-95ba-910f6356ddc6",
    // "15d46bac-1612-4636-aad2-f44703255e11",
    // "b681e36f-c16a-468f-9a77-7efa92438929",
    // "1d8181bb-2a9f-4573-8e88-9677f9b0697b",
    // "a9ddbd18-c8b0-40df-832e-3e5194bd2d63",
    // "89fe57ec-186b-4e7a-9e75-6eae3746629b",
  ];

  uploadFailed = "upload_failed";

  private randomize() {
    // add random number to GET request to bypass cache
    return Math.floor(Math.random() * 100000000);
  }

  private sortByDate (a: Asset, b: Asset) {
    // more recent first
    return b.createdDate - a.createdDate;
  }

  public async getMeetingToken() {

  }

  public async loadAssets(isOrganizer: boolean = false) {

    if (!this.userService.user) return;

    let headers = this.userService.addJWTAuthenticationHeader({})
    let uid = this.userService.user.id;
    let authKind = 'user';
    if (!isOrganizer) {
      console.log('load users assets', this.userService.user);
    } else {
      authKind = 'event'; // get auth at meeting level
      // use meeting authentication id
      const currentEvent = this.ptApiService.ptCurrentEventInformation$.getValue();
      const organizerId = currentEvent[1].organizerId;
      if (organizerId === uid) {
        // organizer is the current user -> do nothing
        return;
      }
      uid = organizerId;
      const token = this.ptApiService.getEventToken();
      console.log('Meeting token for assets', token)
      headers['Authorization'] = `Bearer ${token}`;
      console.log('load organizer assets', organizerId);
    }


    fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/${authKind}/${uid}/assets?_=${this.randomize()}`, {
      headers: headers
    })
    .then((assets: any) => {
      // TODO remove deletedAssets filtering when delete assets is FIXED
      const filteredAssets = [];

      console.log('loaded assets', assets);
      assets?.assets?.forEach((asset: Asset) => {
        asset.studioMediaType = tagMediaTypeMapping[asset.tag] || undefined;
        if (!this.deletedAssets.includes(asset.id)) {
            filteredAssets.push(asset);
        }
      })
      if (!isOrganizer) {
        this.assetList$.next(filteredAssets.sort(this.sortByDate));
      } else {
        this.assetListOrg$.next(filteredAssets.sort(this.sortByDate));
      }
    })
  }

  public async uploadFile(file: any, mediaType: MediaType) {
    if (!this.userService.jwtToken$.getValue()) {
      await new Promise(
        (f, r) => {
          setTimeout(_ => {
            f('');
          }, 3000)
        })
    }
    // Request presigned url :
    await fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/user/${this.userService.user.id}/uploadUrl`, {
      method: 'POST',
      body: JSON.stringify({
        type: mediaType === MediaType.FG_IMAGE || mediaType === MediaType.BG_IMAGE || mediaType === MediaType.LOGO ? "image" : "video",
      }),
      headers: this.userService.addJWTAuthenticationHeader({})
    }).then((presignedUrls: any) => {

      fetchBinaryAndThrowHttpErrors(
        'PUT',
        `${(location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "dev-bluejeans-studio.envrmnt.com")  ? 'https://cors-anywhere.herokuapp.com/' : ''}${presignedUrls.assetUrl}`,
        file,  // upload binary file  (not a form)
        // progress
        (percent) => {
          if (percent < 100) {
            // keep 100 when upload is completed
            this.uploadPercentage$.next(percent);
          }
        },
        // completed
        () => {
          this.uploadPercentage$.next(100);
          localStorage.setItem('assetLastUploadDate', Date.now().toString());


          let body= null;
          const type = (mediaType === MediaType.FG_VIDEO || mediaType === MediaType.BG_VIDEO) ? "video" : "image";
          if (type === 'image') {
            body = {
              "type":  type,
              "tag": 'STUDIO_' + mediaType.toString(), // Object.keys(tagMediaTypeMapping).find(tag => tagMediaTypeMapping[tag] === mediaType),
              "assetKey": presignedUrls.assetKey,
              "title": file.name
            }
          } else {
            body = {
              "type":  type,
              "tag": 'STUDIO_' + mediaType.toString(), // Object.keys(tagMediaTypeMapping).find(tag => tagMediaTypeMapping[tag] === mediaType),
              "assetKey": presignedUrls.assetKey,
              "thumbnailKey": presignedUrls.thumbnailKey,
              "title": file.name
            }
          }
          fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/user/${this.userService.user.id}/assets`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: this.userService.addJWTAuthenticationHeader({})
          })
          .then((asset) => {
            console.log('new asset id', asset);
            this.uploadAssetKey$.next(asset.id);
          }, (error) => {
            this.uploadAssetKey$.next(this.uploadFailed);
          })

        },
        // error callback
        () => {
          this.uploadAssetKey$.next(this.uploadFailed);
        }
      )
        .then(_ => {
        })
    })
    return;
  }


  public async deleteAsset(assetId) {
    if (this.userService.user) {
      fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/user/${this.userService.user.id}/assets/${assetId}`, {
        method: 'DELETE',
        headers: this.userService.addJWTAuthenticationHeader({})
      })
        .then(_ => {
        })
    }
  }

  public async renameAsset(assetId: string, assetName: string) {
    // find asset
    const asset = this.assetList$.getValue().find(a => a.id === assetId);

    if (asset) {
      asset.title = assetName;
      const body = {
        title: assetName,
      }
      fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/user/${this.userService.user.id}/assets/${assetId}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: this.userService.addJWTAuthenticationHeader({})
      })
      .then(_ => {
        // empty response returned by update
      }, (error) => {
        console.log('asset update failed ', error)
      })

    }
  }

  public async refreshAsset(assetId) {
    // find asset
    const assets = R.clone(this.assetList$.getValue());
    const asset = assets.find(a => a.id === assetId);

    if (asset) {
      fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/assets?id=${assetId}`, {
        method: 'GET',
        headers: this.userService.addJWTAuthenticationHeader({})
      })
      .then((updAsset)=> {
        console.log("updated Asset", updAsset);
        // update asset in assets list
        asset.assetDownloadUrl = updAsset.assetDownloadUrl;
        asset.assetThumbnailUrl = updAsset.assetThumbnailUrl;
        asset.status = updAsset.status;
        // update queue
        this.assetList$.next(assets);
      }, (error) => {
        console.log('asset update failed ', error)
      })
    }

  }

}